/* eslint-disable no-template-curly-in-string */
import { Popover } from "antd";
import React, { useMemo } from "react";
import "./index.less";
import { useTranslation } from "react-i18next";
import { isBjme } from "@/utils";
import findKey from "lodash/findKey";
import classNames from "classnames";
import { stickers_sets } from "@/components/chat/utils/stickers-config";
import { cache } from "@/components/chat/utils/ddemoji";
import GraphemeSplitter from "grapheme-splitter";
const emoji_str = `🙂😏☺😉🤪😀😅🤣😇😆😟😙😬😮😧😦😫🤕😑😐😶☹️🥰🤩🤫🤨🤤😂🤬😣😌😄😯😖😲😃😔😚👿😥😩🤒🙃🤑🤓😰😗😛😜😝😷😞😠😎😭😂😳🤐😕😡🤗😏👌✌👍💪👏🤝👋😊😉😁😍😘😋😵😴😯🙁🙄🤔😨😱😓😒😣😤💀🙈🐶👆👇👈👉✊🙏💯🉑💡📅📄📧📁📱💻🔗📌❌❓🚩📢❤💔🎁💰🌹🥀☕🍺🍗🎉🎂🔥💣⚫🔺🔷📌📢🔔💡`;

const emoji_mebj_array = [
  "🙂",
  "😕",
  "[吓]",
  "🤐",
  "😴",
  "😢",
  "😓",
  "😁",
  "🙁",
  "🤭",
  "😊",
  "😪",
  "[憨笑]",
  "[奋斗]",
  "😭",
  "[疑问]",
  "[拥抱]",
  "👍",
  "🤝",
  "✌",
  "[抱拳]",
  "👏",
  "👌",
  "💪",
  "🙏",
  "☕",
  "🌛",
  "🌞",
  "🎂",
  "🌹",
  "🎁",
  "🎉",
  "[警报]",
  "[收到]",
  "📢",
  "[红星]",
  "🔺",
  "⚫",
  "💡",
  "📌"
];

export function getEmojis(): string[] {
  if (isBjme()) {
    const all = emoji_mebj_array.concat(Array.from(emoji_str).filter((item) => !!item));
    return Array.from(new Set(all)).filter((str) => !!str);
  } else {
    return Array.from(emoji_str).filter((item) => !!item);
  }
}

function EmojiContent({ onclick }: { onclick: (str: string) => void }) {
  const [t] = useTranslation("chat");
  const emojiArray = emoji_mebj_array;
  return (
    <div className="emoji-container">
      {/* 所有表情 */}
      <div className="emoji-all">
        <div className="emoji-all-title">{t("all_emoji")}</div>
        <div className="emoji-all-content">
          {emojiArray.map((e: string, i: number) => {
            return (
              <div className="emoji-item" key={i} onClick={() => onclick(e)}>
                <img
                  className="dd-emoji"
                  data-id={`dd-emoji-${e.slice(3)}`}
                  src={cache[`./${stickers_sets[e]}`]}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default function EmojiPopover({
  children,
  onclick,
  visible,
  onVisibleChange,
  placement
}: {
  children: any;
  visible: boolean;
  onclick: (str: string) => void;
  onVisibleChange: (visible: boolean) => void;
  placement?: any;
}) {
  function handleClick(str: string) {
    onclick(str);
    onVisibleChange(false);
  }

  const classes = useMemo(() => {
    return classNames({
      "emoji-popover": true,
      mebj: isBjme()
    });
  }, []);

  return (
    <Popover
      trigger="click"
      overlayClassName={classes}
      placement={placement || "top"}
      visible={visible}
      onVisibleChange={(visible) => {
        onVisibleChange(visible);
      }}
      content={<EmojiContent onclick={handleClick} />}
    >
      {children}
    </Popover>
  );
}

export function mattchEmoji(content: string) {
  let result = content;
  if (!content) {
    return "";
  }
  const emojiArray = getEmojis();
  emojiArray.forEach((e: string, i: number) => {
    const pattern = new RegExp(e, "g");
    const ispattern = result.indexOf(e);
    if (!stickers_sets[e]) {
      return;
    }
    if (ispattern !== -1) {
      result = result.replace(
        pattern,
        // e,
        `<img class="dd-emoji" data-id="dd-emoji-${e.slice(3)}" src="${
          cache[`./${stickers_sets[e]}`]
        }" data-value="${getEmojiCode(e)}" draggable="false">`
      );
    }
  });
  return result;
}
export function getEmojiCode(emoji: string): string {
  const emojiArray = getEmojis();
  const data = findKey(emojiArray, (v, k) => {
    return v === emoji;
  });
  return data || "";
}

export function getNewEmoji(code: string): string {
  const emojiArray = getEmojis();
  let V: any;
  findKey(emojiArray, (v, k) => {
    if (k === code) {
      V = v;
    }
    return V;
  });
  return V || "";
}

// 删除emoji表情
export function deleteEmojiStr(content: string): string {
  if (!content) {
    return content;
  }
  let newStr = content;
  let bracketsRegex = /\[.*?\]/g;
  let simpleRegex = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  let specialRegex = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f\ude80-\udeff])|[\u2600-\u2B55]/;
  let allRegex = [bracketsRegex, simpleRegex];

  allRegex.forEach((item) => {
    newStr = newStr.replace(item, "");
  });
  if (specialRegex.test(newStr)) {
    let newArray = [];
    let splitter = new GraphemeSplitter();
    // emoji分割成数组
    let graphemes = splitter.splitGraphemes(newStr);
    // eslint-disable-next-line
    for (let i = 0; i < graphemes.length; i++) {
      if (!specialRegex.test(graphemes[i])) {
        newArray.push(graphemes[i]);
      }
    }
    newStr = newArray.join("");
  }

  return newStr;
}
